import styled from 'styled-components';
import { colors } from '@/styles';

export const BooleanSelect = styled.select`
  appearance: none;

  box-sizing: border-box;
  inline-size: 100%;
  block-size: 100%;
  padding-block: 0;
  padding-inline: 6px;
  vertical-align: top;
  font-family: inherit;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #999;
    opacity: 1;
  }
`;

export const NumericInput = styled.input`
  appearance: none;

  box-sizing: border-box;
  inline-size: 100%;
  block-size: 100%;
  padding-block: 0;
  padding-inline: 6px;
  vertical-align: top;
  font-family: inherit;

  text-align: right;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #999;
    opacity: 1;
  }
`;
